import React from 'react';
import { motion } from 'framer-motion';
const modules = [{
  num: '1',
  title: 'Evaluación inicial del deportista con discapacidad',
  desc: 'Protocolo de primer contacto para evaluar historia deportiva, perfil mental, relación con la discapacidad y objetivos.'
}, {
  num: '2',
  title: 'Impacto psicológico de la discapacidad en el rendimiento',
  desc: 'Comprendé cómo la discapacidad influye en identidad deportiva, autoconfianza, motivación y presión competitiva.'
}, {
  num: '3',
  title: 'Planificación del trabajo mental adaptado',
  desc: 'Convertí la evaluación inicial en objetivos claros, técnicas adaptadas y un plan ajustado al deporte y tipo de discapacidad.'
}, {
  num: '4',
  title: 'Intervención en sesiones individuales',
  desc: 'Protocolo para sesiones de rendimiento adaptado: apertura, foco mental, herramienta, aplicación deportiva y cierre.'
}, {
  num: '5',
  title: 'Gestión emocional de la discapacidad adquirida',
  desc: 'Acompañá al deportista que adquirió una discapacidad: duelo deportivo, readaptación, nueva identidad y regreso a la competencia.'
}, {
  num: '6',
  title: 'Preparación mental para la competencia adaptada',
  desc: 'Diseñá rutinas precompetitivas y trabajá activación, concentración, presión y respuesta ante errores e imprevistos.'
}, {
  num: '7',
  title: 'Trabajo con el entorno y cuerpo técnico',
  desc: 'Coordiná con entrenadores, familia y equipo médico sin romper confidencialidad ni quitar autonomía al deportista.'
}, {
  num: '8',
  title: 'Seguimiento y cierre del proceso',
  desc: 'Monitoreá avances, ajustá objetivos, hacé devoluciones profesionales y cerrá el proceso dejando autonomía en el deportista.'
}];
export function Modules() {
  return <section className="py-10 sm:py-16 bg-[#f8fafc]" data-id="element-105">
      <div className="container px-3 sm:px-4 mx-auto max-w-5xl" data-id="element-106">
        <div className="text-center mb-8 sm:mb-12" data-id="element-107">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-black text-[#0c3b42] mb-3 sm:mb-4 uppercase tracking-tight" data-id="element-108">
            QUÉ INCLUYE EL KIT PSICOLOGÍA EN DEPORTE ADAPTADO
          </h2>
          <p className="text-sm sm:text-xl font-bold text-[#7fd1c9] bg-[#0c3b42] inline-block px-4 sm:px-6 py-1.5 sm:py-2 rounded-full" data-id="element-109">
            Sistema Clínico Adaptado 8 Etapas™
          </p>
          <p className="text-base sm:text-lg text-slate-600 mt-4 sm:mt-6" data-id="element-110">
            Una estructura profesional en 8 módulos:
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:gap-6" data-id="element-111">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="bg-white p-3.5 sm:p-6 md:p-8 rounded-xl sm:rounded-2xl border-2 border-slate-100 shadow-sm relative overflow-hidden group hover:border-[#7fd1c9] transition-colors" data-id="element-112">
              <div className="absolute -right-3 -top-3 sm:-right-6 sm:-top-6 text-5xl sm:text-9xl font-black text-slate-50 opacity-50 group-hover:text-[#e0f2fe] transition-colors pointer-events-none" data-id="element-113">
                {mod.num}
              </div>
              <div className="relative z-10" data-id="element-114">
                <div className="w-7 h-7 sm:w-10 sm:h-10 bg-[#0c3b42] text-[#7fd1c9] font-black text-sm sm:text-xl rounded-md sm:rounded-lg flex items-center justify-center mb-2 sm:mb-4" data-id="element-115">
                  {mod.num}
                </div>
                <h3 className="text-sm sm:text-xl font-bold text-[#0c3b42] mb-1.5 sm:mb-3 pr-4 sm:pr-8 leading-snug" data-id="element-116">
                  {mod.title}
                </h3>
                <p className="text-xs sm:text-base text-slate-600 leading-relaxed" data-id="element-117">
                  {mod.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}